import { Translations } from './translations';
import { en } from './en';

export const ar: Translations = {
  ...en,
  nav: {
    ...en.nav,
    services: 'الخدمات',
    innovation: 'الابتكار',
    about: 'من نحن',
    getInTouch: 'تواصلوا معنا',
    openMenu: 'فتح قائمة التنقل',
    closeMenu: 'إغلاق قائمة التنقل',
  },
};
